var _defs, _g, _path, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _g4, _g5, _path9, _path10, _path11, _path12, _path13, _g6, _path14, _g7, _path15, _path16, _path17, _path18, _path19, _path20, _g8, _path21, _g9, _path22, _path23, _path24, _path25, _path26, _path27, _g10, _path28, _g11, _path29, _path30, _path31, _path32, _path33, _g12, _path34, _g13, _path35, _path36, _g14, _path37, _g15, _g16, _g17, _path38, _g18, _g19, _path39, _path40, _path41, _path42, _path43, _path44, _g20, _g21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImplicitExercise = function SvgImplicitExercise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h119.876v293.932H0z",
    "data-name": "Rectangle 33358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24.13v25.614H0z",
    "data-name": "Rectangle 33338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36.559v38.807H0z",
    "data-name": "Rectangle 33339"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24.98v165.452H0z",
    "data-name": "Rectangle 33341"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h15.596v92.243H0z",
    "data-name": "Rectangle 33342"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h9.937v5.907H0z",
    "data-name": "Rectangle 33343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h9.944v5.907H0z",
    "data-name": "Rectangle 33344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h17.107v93.763H0z",
    "data-name": "Rectangle 33349"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h18.397v5.983H0z",
    "data-name": "Rectangle 33350"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h66.997v20.789H0z",
    "data-name": "Rectangle 33351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.765v2.912H0z",
    "data-name": "Rectangle 33352"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32.89v32.84H0z",
    "data-name": "Rectangle 33353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h43.658v80.213H0z",
    "data-name": "Rectangle 33354"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20.971v57.874H0z",
    "data-name": "Rectangle 33355"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64.701v32.851H0z",
    "data-name": "Rectangle 33356"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58416"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#f2f2f2",
    "data-name": "Rectangle 33478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 480,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 919,
    height: 479,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58393"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M466.972 66.999c90.758 0 151.1 77.538 151.1 173.187s-60.341 173.187-151.1 173.187c-56.724 0-88.023-21.356-117.979-68.089-17.295-26.976-46.353-69.23-46.353-105.098 0-95.649 73.574-173.187 164.332-173.187",
    "data-name": "Path 51087"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58112"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__a)",
    "data-name": "Group 58171",
    transform: "translate(409.394 119.441)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58170"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__a)",
    "data-name": "Group 58169"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#152429",
    d: "M32.366 132.764c2.1-1.116 2.21 1.873 6.226 4.715 10.487 7.425-.592 47.39-7.6 74.546-3.632 14.073-10.217 22.264-17.2 23.182-6 .788-15.3-5.165-13.339-17.414 3.185-19.87 8.681-35.939 14.017-55.758 3.3-12.267 8.97-24.532 17.9-29.268",
    "data-name": "Path 51089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0a47c",
    d: "M47.809 131.064c.695 5.136 4.987 11.064 13.384 9.855 8.415-1.211 9.935-8.15 9.257-13.167l-4.585-33.877-21.316 13.139 3.255 24.05",
    "data-name": "Path 51090"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58114",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58113"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__b)",
    "data-name": "Group 58112",
    transform: "translate(44.872 96.856)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M24.13 20.834a27.9 27.9 0 0 1-11.495 4.5 27.3 27.3 0 0 1-11.078-.684L-.001 13.14 21.31.001l2.819 20.834",
    "data-name": "Path 51091"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8eaef",
    d: "M27.103 141.244s14.565-15.415 18.668-17.321l.445 3.285c.924 6.829 3.675 13.746 8.925 12.979 5.4-.79 16.514-9.735 15.59-16.565l-.445-3.285c4.451.656 5.989 2.143 5.989 2.143l17.982 143.86s-10.7 1.226-31.094-.831c-17.076-1.721-22.445-9.376-22.445-9.376Z",
    "data-name": "Path 51092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa0e0e",
    d: "m53.384 157.898-5.073-12.642 6.3-5.249 6.96 6.008-4.278 11.683s.8 21.688 2.528 41.493c1.672 19.126 3.3 45.777 3.3 45.777l-8.438 14.513-6.137-17.263s1.165-24.369 1.532-34.888c1.074-30.781 3.307-49.434 3.307-49.434",
    "data-name": "Path 51093"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58117",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58116"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__c)",
    "data-name": "Group 58115",
    transform: "translate(40.597 120.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "m0 9.33 5.859-5.891 8.035 16.034L29.364 0l7.2 3.982-12.129 32.691-10.1-15.4-9.283 17.53Z",
    "data-name": "Path 51094"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.854 127.715 5.649-5.863 8.175 18.235-8.873 17.346Z",
    "data-name": "Path 51095"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m76.248 122.536-6.986-4.013-14.588 21.562 10.246 14.732Z",
    "data-name": "Path 51096"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "M117.637 188.346c3.982 40.569 1.634 81.54.667 89.792-6.25 6.385-38.619 15.156-51.352 15.794 0 0 .307-39.234 0-77.033-.074-8.95-.872-18.526-.723-24.266.753-29.18 7.557-70.822 7.557-70.822a40.4 40.4 0 0 1 7.483 1.291c8.972 2.652 30.489 5.365 36.368 65.243",
    "data-name": "Path 51097"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58123",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58122"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__d)",
    "data-name": "Group 58121",
    transform: "translate(21.746 126.542)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58120",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58119"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__d)",
    "data-name": "Group 58118"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M3.628 80.574c11.033 56.047 3.15 56.86 3.15 56.86 0 7.852 4.442 24.228 12.567 28.018 0 0 7.4-8.735 5.241-63.591-.355-9.031-2.4-32.571-2.467-37.384-.115-8.4-1.541-42.277-.158-64.477-2.333 1.03-2.388 1.36-4.576 2.74C9.747 7.555-7.476 24.174 3.628 80.573",
    "data-name": "Path 51098"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58126",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58125"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__e)",
    "data-name": "Group 58124",
    transform: "translate(26.916 126.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "m5.695 6.84 9.9-6.84s-1.344 13.719-3.2 34.413c-1.575 17.6 2.978 57.83 2.978 57.83L.593 44.116l6.926-8.1-7.518-4.762Z",
    "data-name": "Path 51099"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "M23.46 211.557c9.6 41.32 6.257 47.548 1.24 53.233-1.946 2.205 4.3 21.39 13.38 26.264 0 0 7.515-30.354 4.208-63.964-.885-8.985-.974-16.28-1.371-21.071-2.947-35.706 2.615-79.779 2.615-79.779a54 54 0 0 0-6.851 3.695c-7.638 4.815-26.205 25.744-13.22 81.622",
    "data-name": "Path 51100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "m32.465 131.889 11.393-7.23s-1.342 13.72-3.2 34.412c-1.574 17.6 1.636 59.683 1.636 59.683l-13.445-49.98 6.927-8.1-7.518-4.757Z",
    "data-name": "Path 51101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "M36.579 227.33a2.165 2.165 0 0 0 2.43 1.9 2.22 2.22 0 0 0 1.831-2.523 2.17 2.17 0 0 0-2.433-1.906 2.223 2.223 0 0 0-1.832 2.529",
    "data-name": "Path 51102"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "M37.499 251.605a2.07 2.07 0 0 0 1.677 2.346 2.05 2.05 0 0 0 1.946-2.117 2.076 2.076 0 0 0-1.682-2.351 2.05 2.05 0 0 0-1.941 2.121",
    "data-name": "Path 51103"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M17.571 87.491a6.553 6.553 0 0 0 5.389-7.439 6.39 6.39 0 0 0-7.156-5.608l-4.968.727a6.554 6.554 0 0 0-5.385 7.442 6.383 6.383 0 0 0 7.15 5.6Z",
    "data-name": "Path 51104"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58129",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58128"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58127",
    transform: "translate(9.238 78.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.798 5.157a2.576 2.576 0 0 0 2.114-2.922A2.516 2.516 0 0 0 7.103.025L2.135.751A2.58 2.58 0 0 0 .024 3.679a2.506 2.506 0 0 0 2.8 2.2Z",
    "data-name": "Path 51105"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M84.061 77.764a6.553 6.553 0 0 0 5.393-7.438 6.39 6.39 0 0 0-7.159-5.608l-4.964.727a6.56 6.56 0 0 0-5.392 7.445 6.39 6.39 0 0 0 7.158 5.6Z",
    "data-name": "Path 51106"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58132",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58131"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58130",
    transform: "translate(75.724 68.649)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.801 5.155a2.57 2.57 0 0 0 2.118-2.921A2.514 2.514 0 0 0 7.106.026L2.142.752A2.58 2.58 0 0 0 .024 3.681a2.51 2.51 0 0 0 2.811 2.2Z",
    "data-name": "Path 51107"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M39.697 19.177c-17.795 2.6-30.614 16.6-28.11 35.1l5.804 42.878c2.5 18.5 19.349 34.268 37.145 31.664s29.806-22.592 27.3-41.09l-5.8-42.879c-2.5-18.5-18.544-28.274-36.336-25.671",
    "data-name": "Path 51108"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M44.061 86.633a9.44 9.44 0 0 0 4.691.209 13.1 13.1 0 0 0 4.54-1.491 4.293 4.293 0 0 1-3.811 4.807c-3.86.668-5.32-2.181-5.42-3.529",
    "data-name": "Path 51109"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m53.601 55.574 9.909 3.8a1.337 1.337 0 0 0 1.73-.829 1.417 1.417 0 0 0-.8-1.8l-9.91-3.8a1.334 1.334 0 0 0-1.729.828 1.42 1.42 0 0 0 .8 1.8",
    "data-name": "Path 51110"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M32.987 64.884a1.43 1.43 0 0 0 .437-1.545 1.336 1.336 0 0 0-1.708-.876l-10.251 3.623a1.413 1.413 0 0 0-.84 1.775 1.333 1.333 0 0 0 1.707.874l10.252-3.621a1.4 1.4 0 0 0 .4-.23",
    "data-name": "Path 51111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M7.09 38.142c-2.014-15.83 9.686-26.148 9.686-26.148 4.813-4.754 11.388-7.675 17.731-9.439-1.163 2.454-3.14 6.749-1.936 5.193C35.864 3.485 44.38 1.065 47.952.207c4.314-.347 7.2-.189 7.2-.018.05 4.121-5.812 8.558-2.893 8.162 4.241-.569 7.929-6.464 8.715-5.918 12.747 8.843 14.47 21.1 15.13 28.068.776 8.136 2.739 34.439 2.739 34.439s-2.71-15.177-3.475-20.88C73.946 33.447 65.319 24.91 57.53 30.414c-5.474 3.873-9.561 5.335-18.117 5.586-13.146.374-16.344.2-19.525.326-7 .289-9.009 7.3-8.167 13.527C12.285 54 14.167 73 14.167 73S8.482 49.081 7.09 38.142",
    "data-name": "Path 51112"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M17.571 87.491a6.553 6.553 0 0 0 5.389-7.439 6.39 6.39 0 0 0-7.156-5.608l-4.968.727a6.554 6.554 0 0 0-5.385 7.442 6.383 6.383 0 0 0 7.15 5.6Z",
    "data-name": "Path 51113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58135",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58134"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58133",
    transform: "translate(9.238 78.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.798 5.157a2.576 2.576 0 0 0 2.114-2.922A2.516 2.516 0 0 0 7.103.025L2.135.751A2.58 2.58 0 0 0 .024 3.679a2.506 2.506 0 0 0 2.8 2.2Z",
    "data-name": "Path 51114"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M84.061 77.764a6.553 6.553 0 0 0 5.393-7.438 6.39 6.39 0 0 0-7.159-5.608l-4.964.727a6.56 6.56 0 0 0-5.392 7.445 6.39 6.39 0 0 0 7.158 5.6Z",
    "data-name": "Path 51115"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58138",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58137"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58136",
    transform: "translate(75.724 68.649)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.801 5.155a2.57 2.57 0 0 0 2.118-2.921A2.514 2.514 0 0 0 7.106.026L2.142.752A2.58 2.58 0 0 0 .024 3.681a2.51 2.51 0 0 0 2.811 2.2Z",
    "data-name": "Path 51116"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M39.697 19.177c-17.795 2.6-30.614 16.6-28.11 35.1l5.804 42.878c2.5 18.5 19.349 34.268 37.145 31.664s29.806-22.592 27.3-41.09l-5.8-42.879c-2.5-18.5-18.544-28.274-36.336-25.671",
    "data-name": "Path 51117"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M44.061 86.633a9.44 9.44 0 0 0 4.691.209 13.1 13.1 0 0 0 4.54-1.491 4.293 4.293 0 0 1-3.811 4.807c-3.86.668-5.32-2.181-5.42-3.529",
    "data-name": "Path 51118"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m53.601 55.574 9.909 3.8a1.337 1.337 0 0 0 1.73-.829 1.417 1.417 0 0 0-.8-1.8l-9.91-3.8a1.334 1.334 0 0 0-1.729.828 1.42 1.42 0 0 0 .8 1.8",
    "data-name": "Path 51119"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M32.987 64.884a1.43 1.43 0 0 0 .437-1.545 1.336 1.336 0 0 0-1.708-.876l-10.251 3.623a1.413 1.413 0 0 0-.84 1.775 1.333 1.333 0 0 0 1.707.874l10.252-3.621a1.4 1.4 0 0 0 .4-.23",
    "data-name": "Path 51120"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M7.09 38.142c-2.014-15.83 9.686-26.148 9.686-26.148 4.813-4.754 11.388-7.675 17.731-9.439-1.163 2.454-3.14 6.749-1.936 5.193C35.864 3.485 44.38 1.065 47.952.207c4.314-.347 7.2-.189 7.2-.018.05 4.121-5.812 8.558-2.893 8.162 4.241-.569 7.929-6.464 8.715-5.918 12.747 8.843 14.47 21.1 15.13 28.068.776 8.136 2.739 34.439 2.739 34.439s-2.71-15.177-3.475-20.88C73.946 33.447 65.319 24.91 57.53 30.414c-5.474 3.873-9.561 5.335-18.117 5.586-13.146.374-16.344.2-19.525.326-7 .289-9.009 7.3-8.167 13.527C12.285 54 14.167 73 14.167 73S8.482 49.081 7.09 38.142",
    "data-name": "Path 51121"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M17.571 87.491a6.553 6.553 0 0 0 5.389-7.439 6.39 6.39 0 0 0-7.156-5.608l-4.968.727a6.554 6.554 0 0 0-5.385 7.442 6.383 6.383 0 0 0 7.15 5.6Z",
    "data-name": "Path 51122"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58141",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58140"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58139",
    transform: "translate(9.238 78.375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.798 5.157a2.576 2.576 0 0 0 2.114-2.922A2.516 2.516 0 0 0 7.103.025L2.135.751A2.58 2.58 0 0 0 .024 3.679a2.506 2.506 0 0 0 2.8 2.2Z",
    "data-name": "Path 51123"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M84.061 77.764a6.553 6.553 0 0 0 5.393-7.438 6.39 6.39 0 0 0-7.159-5.608l-4.964.727a6.56 6.56 0 0 0-5.392 7.445 6.39 6.39 0 0 0 7.158 5.6Z",
    "data-name": "Path 51124"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58144",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58143"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58142",
    transform: "translate(75.724 68.649)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.801 5.155a2.57 2.57 0 0 0 2.118-2.921A2.514 2.514 0 0 0 7.106.026L2.142.752A2.58 2.58 0 0 0 .024 3.681a2.51 2.51 0 0 0 2.811 2.2Z",
    "data-name": "Path 51125"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M39.697 19.177c-17.795 2.6-30.614 16.6-28.11 35.1l5.804 42.878c2.5 18.5 19.349 34.268 37.145 31.664s29.806-22.592 27.3-41.09l-5.8-42.879c-2.5-18.5-18.544-28.274-36.336-25.671",
    "data-name": "Path 51126"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M44.061 86.633a9.44 9.44 0 0 0 4.691.209 13.1 13.1 0 0 0 4.54-1.491 4.293 4.293 0 0 1-3.811 4.807c-3.86.668-5.32-2.181-5.42-3.529",
    "data-name": "Path 51127"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m53.601 55.574 9.909 3.8a1.337 1.337 0 0 0 1.73-.829 1.417 1.417 0 0 0-.8-1.8l-9.91-3.8a1.334 1.334 0 0 0-1.729.828 1.42 1.42 0 0 0 .8 1.8",
    "data-name": "Path 51128"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M32.987 64.884a1.43 1.43 0 0 0 .437-1.545 1.336 1.336 0 0 0-1.708-.876l-10.251 3.623a1.413 1.413 0 0 0-.84 1.775 1.333 1.333 0 0 0 1.707.874l10.252-3.621a1.4 1.4 0 0 0 .4-.23",
    "data-name": "Path 51129"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M7.09 38.142c-2.014-15.83 9.686-26.148 9.686-26.148 4.813-4.754 11.388-7.675 17.731-9.439-1.163 2.454-3.14 6.749-1.936 5.193C35.864 3.485 44.38 1.065 47.952.207c4.314-.347 7.2-.189 7.2-.018.05 4.121-5.812 8.558-2.893 8.162 4.241-.569 7.929-6.464 8.715-5.918 12.747 8.843 14.47 21.1 15.13 28.068.776 8.136 2.739 34.439 2.739 34.439s-2.71-15.177-3.475-20.88C73.946 33.447 65.319 24.91 57.53 30.414c-5.474 3.873-9.561 5.335-18.117 5.586-13.146.374-16.344.2-19.525.326-7 .289-9.009 7.3-8.167 13.527C12.285 54 14.167 73 14.167 73S8.482 49.081 7.09 38.142",
    "data-name": "Path 51130"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58147",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58146"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__h)",
    "data-name": "Group 58145",
    transform: "translate(67.524 121.549)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M17.107 2.704 7.016.004A180.7 180.7 0 0 0 .124 45.248c-.457 23.414.5 48.518.5 48.518L15.58 44.269l-9.022-8.878 10.285-3.2Z",
    "data-name": "Path 51131"
  }))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "m84.804 123.669-11.747-3.282a180.6 180.6 0 0 0-6.894 45.243c-.457 23.414 1.984 49.681 1.984 49.681l13.473-50.655-9.021-8.88 10.288-3.195Z",
    "data-name": "Path 51132"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58150",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58149"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__i)",
    "data-name": "Group 58148",
    transform: "translate(41.663 97.749)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3673a",
    d: "M.954 5.983A.93.93 0 0 1 .34 5.75a1.02 1.02 0 0 1-.117-1.4c.069-.084 6.928-8.349 17.7-1.877a1.015 1.015 0 0 1 .349 1.357.935.935 0 0 1-1.305.363C7.573-1.451 1.928 5.337 1.691 5.628a.94.94 0 0 1-.733.354",
    "data-name": "Path 51133"
  }))))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2919",
    d: "M33.381 75.499a3.427 3.427 0 1 1-3.424-3.56 3.493 3.493 0 0 1 3.424 3.56",
    "data-name": "Path 51134"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2919",
    d: "M66.113 70.698a3.427 3.427 0 1 1-3.424-3.56 3.494 3.494 0 0 1 3.424 3.56",
    "data-name": "Path 51135"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58153",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58152"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__j)",
    "data-name": "Group 58151",
    transform: "translate(14.868 72.747)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M39.09 6.211c.429-1.8 3.848-3.056 5.988-3.522C49.15 1.795 57.692.032 62.286 0c4.594-.051 4.358 2.276 4.627 5.53.251 2.891.278 5.858-5.052 7.339a69.2 69.2 0 0 1-15.306 2.22c-4.251.109-5.809-1.322-6.749-3.238a9 9 0 0 1-.715-5.639M3.472 8.532c4.423-1.277 13.107-2.013 17.251-2.311 2.187-.16 5.806.073 6.693 1.685a9.15 9.15 0 0 1 .805 5.626c-.4 2.111-1.535 3.931-5.642 5.034a69 69 0 0 1-15.314 2.222c-5.5.091-6.263-2.769-6.791-5.621-.59-3.208-1.412-5.381 3-6.635",
    "data-name": "Path 51136"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#052c35",
    d: "M85.3 71.589a1.3 1.3 0 0 0-1.051-.218 36 36 0 0 1-3.663.187c-.638.016-1.342.032-2.124.056a99 99 0 0 0-9.855.989c-3.436.5-6.567 1.094-9.059 1.717a32.8 32.8 0 0 0-6.117 2.208 18.17 18.17 0 0 1-11.611 1.683 32.7 32.7 0 0 0-6.467-.382c-2.553.108-5.719.428-9.154.926-3.694.535-7.336 1.23-9.748 1.851-.763.2-1.451.39-2.07.556a35 35 0 0 1-3.551.857 1.34 1.34 0 0 0-.97.517 2.07 2.07 0 0 0-.138 1.542l.272 2c.141 1.05.8 1.248 1.617 1.5.682.2 1.4 1.066 2.021 2.421q.088.207.19.467c.657 1.717 1.884 4.916 9.763 4.393 2.379-.163 4.669-.4 6.8-.713a56 56 0 0 0 9.83-2.252c3.037-1.034 3.978-3.618 4.812-5.9.725-1.985 1.35-3.7 3.22-3.973s2.922 1.2 4.141 2.9c1.4 1.958 2.98 4.173 6.178 4.3a55.6 55.6 0 0 0 10.05-.632c2.137-.307 4.4-.733 6.739-1.252 7.723-1.742 8.047-5.173 8.222-7.017q.021-.271.054-.487a4.33 4.33 0 0 1 1.336-2.915c.681-.442 1.275-.826 1.131-1.885l-.23-1.723a8 8 0 0 1-.034-.291 2 2 0 0 0-.531-1.433m-4.077 5.975.059.771c.272 3.118.091 5.61-4.8 6.97a61 61 0 0 1-7.383 1.509 70 70 0 0 1-7.846.7c-4.3.11-5.642-1.4-6.451-3.049a8.7 8.7 0 0 1-.69-5.4c.353-1.46 3.222-2.717 5.743-3.266 3.014-.664 7.436-1.571 11.371-2.142a45 45 0 0 1 5.764-.541c3.91-.042 4.025 1.552 4.236 4.441m-39.4 3.29a8.7 8.7 0 0 1 .767 5.385c-.345 1.812-1.239 3.649-5.4 4.764a70 70 0 0 1-7.743 1.564 61 61 0 0 1-7.493.648c-5.048.082-5.887-2.261-6.456-5.335l-.142-.749c-.553-2.848-.86-4.417 2.906-5.488a45 45 0 0 1 5.679-1.12c3.933-.572 8.427-.956 11.5-1.178 2.568-.19 5.66.2 6.38 1.51",
    "data-name": "Path 51137"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58156",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58155"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__k)",
    "data-name": "Group 58154",
    transform: "translate(46.605 102.048)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3673a",
    d: "M.955 2.912a.93.93 0 0 1-.652-.266 1.01 1.01 0 0 1-.062-1.377C.316 1.182 2.126-.839 6.085.402a1 1 0 0 1 .639 1.238.95.95 0 0 1-1.192.664c-2.728-.858-3.84.261-3.886.311a.95.95 0 0 1-.691.3",
    "data-name": "Path 51138"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58159",
    opacity: 0.37,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58158"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__l)",
    "data-name": "Group 58157",
    transform: "translate(42.824 96.256)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M32.851 16.998s.585-2.73-2.771-1.971-8.9 6.977-8.9 6.977a119.6 119.6 0 0 0-11.233-18.2C7.724.954 6.985.185 5.57.014c-.859-.105-3.311.611-1.605 3.183a61.3 61.3 0 0 1 6.421 12.289s-1.267-1.348-3.358.3c-1.579 1.248-1.166 3.642-1.166 3.642a2.75 2.75 0 0 0-2.482.3 2.85 2.85 0 0 0-1.166 2.883s-2.481.907-2.188 3.032a32.6 32.6 0 0 0 2.765 6.719 27.1 27.1 0 0 0 8.924.2 28.1 28.1 0 0 0 12.4-5.122c2.929-5.706 8.738-10.442 8.738-10.442",
    "data-name": "Path 51139"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58162",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58161"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__m)",
    "data-name": "Group 58160",
    transform: "translate(61.127 141.502)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "M40.336.586c3.026 2.98 3.463 13.18 3.29 17.912-.637 17.552-6.774 37.434-16.067 51.322-13.16 19.666-32.327 8.644-26.476-10.017 3.543-11.3 11.119-14.6 19.23-42.088 1.662-5.629 5-10.958 8.6-13.909 2.1-1.72 9.427-5.186 11.423-3.22",
    "data-name": "Path 51140"
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "M99.958 135.856a14.65 14.65 0 0 1 4.619 11.426c-.638 17.551-8.549 40.365-21.184 62.26-10.512 18.215-27.511 7.9-21.661-10.763 3.543-11.3 12.277-21.688 20.387-49.18 1.662-5.63 5-10.958 8.6-13.909 2.1-1.72 7.243-1.8 9.239.166",
    "data-name": "Path 51141"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58165",
    opacity: 0.22,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58164"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__n)",
    "data-name": "Group 58163",
    transform: "translate(61.782 160.185)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152429",
    d: "M16.909 0C9.92 19.719 3.072 28.781.001 38.442a103 103 0 0 0 2.338 12.407c4.239 14.688 12.556 2.371 15.769-1.326 2.652-3.05 3.5-15.347 2.389-24.009-1.121-8.782-2.434-17.872-3.588-25.513",
    "data-name": "Path 51142"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58168",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58167"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__o)",
    "data-name": "Group 58166",
    transform: "translate(28.762 209.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M62.533 19.146s2.854-1.5 2.013-3.811c-.714-1.963-3.454-1.124-3.454-1.124s2.185-1.2 1.7-3.231c-.442-1.861-2.2-1.938-3.235-1.736-13.343 2.606-18.27 1.485-18.715 1.725A68 68 0 0 1 45.1 4.043c1.059-1.351 1.245-2.708.042-3.712-1.331-1.109-3.41.928-3.41.928a94.4 94.4 0 0 0-10.268 9.01l-.049-.532-2.969.482a8 8 0 0 1-.017-.855l-28.431-2.1c.347 9.667.494 18.211.494 18.211l.283 7.378c12.571-1.017 29.327-3.864 29.327-3.864l-.073-.734 3.059-.26-.116-1.258a62.3 62.3 0 0 0 11.225 2.376c5.127.355 10.951.082 15.729-2.236 3.244-1.573 2.216-3.418 2.216-3.418s2.321-1.126 1.863-2.875a1.75 1.75 0 0 0-1.473-1.436",
    "data-name": "Path 51143"
  }))))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ad85",
    d: "M56.834 224.529c-.168-2.407.158-4.143 2.469-7.188 2.914-3.829 11.188-10.112 11.188-10.112s2.079-2.037 3.41-.928c1.2 1 1.015 2.361-.043 3.712a68 68 0 0 0-4.258 6.926c.445-.24 5.373.88 18.715-1.724 1.037-.2 2.794-.125 3.236 1.735.481 2.033-1.7 3.232-1.7 3.232s2.741-.838 3.454 1.125c.841 2.311-2.013 3.81-2.013 3.81a1.75 1.75 0 0 1 1.473 1.436c.458 1.748-1.862 2.875-1.862 2.875s1.028 1.845-2.216 3.419c-4.778 2.318-10.6 2.59-15.728 2.235-3.583-.249-12.543-2.361-14.26-3.634-2.419-1.794-1.716-4.706-1.866-6.921",
    "data-name": "Path 51144"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m56.36 216.33 3.823-.62 1.672 18.256-5.853.5Z",
    "data-name": "Path 51145"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "m57.192 215.338-55.427-4.1s-3.225 9.563-.955 16.764c2.6 8.244 11.541 11.21 21.5 11.178 11.946-.04 36.554-4.222 36.554-4.222s-1.791-18.256-1.672-19.623",
    "data-name": "Path 51146"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd2b3",
    d: "M69.873 149.067s-3.438-15.756-2.708-19.7c1.359-7.348 10.211-14.562 10.211-14.562s.584-2.73-2.771-1.97-8.9 6.976-8.9 6.976a119.7 119.7 0 0 0-11.233-18.2c-2.223-2.851-2.962-3.618-4.377-3.791-.861-.1-3.312.611-1.605 3.184a61.2 61.2 0 0 1 6.42 12.288s-1.267-1.346-3.358.3c-1.579 1.247-1.166 3.641-1.166 3.641a2.75 2.75 0 0 0-2.481.3 2.85 2.85 0 0 0-1.167 2.882s-2.481.91-2.189 3.032c.207 1.51 2.772 7.282 5.4 11.378a12.6 12.6 0 0 0 6.856 5.157l2.517 10.937Z",
    "data-name": "Path 51147"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8eaef",
    d: "M70.491 145.625c.16-.662-1.274-6.955-1.274-6.955l-15.768 3.975 1.116 7.782Z",
    "data-name": "Path 51148"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "m82.915 203.249-11.788-61.765-18.475 5.3s3.664 48.682 7.486 61.929c4.239 14.688 13.539 10.762 18.635 6.292 4.068-3.567 4.142-11.756 4.142-11.756",
    "data-name": "Path 51149"
  })))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58172"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4929",
    d: "M644.741 97.48h112.684c8.644 0 15.651 7.285 15.651 16.271v55.321c0 8.986-7.007 16.271-15.651 16.271h-85.524l-27.16 18.918v-18.918c-8.644 0-15.651-7.285-15.651-16.271v-55.321c0-8.986 7.007-16.271 15.651-16.271",
    "data-name": "Path 51088"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 42,
    fontWeight: 500,
    transform: "translate(697.929 151.396)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.479,
    y: 0
  }, "NO")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58173"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4929",
    d: "M163.651 93.32h112.684c8.644 0 15.651 7.285 15.651 16.271v55.321c0 8.986-7.007 16.271-15.651 16.271v23.078l-31.585-23.078h-81.1c-8.643 0-15.65-7.285-15.65-16.271v-55.321c0-8.986 7.007-16.271 15.651-16.271",
    "data-name": "Path 51088"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 43,
    fontWeight: 500,
    transform: "translate(216.841 148.451)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.786,
    y: 0
  }, "YES")))))));
};
export default SvgImplicitExercise;